import { APIHandler } from "utilities/apiHandler";

import { LookupResponse } from "commonComponents/entity/cellEmailLookup/CellEmailLookup/CellEmailLookup.api.types";

export interface ICellEmailLookupHandler {
    lookup(number: string, allowLandline?: boolean): Promise<LookupResponse>;
}

export class CellEmailLookupHandler implements ICellEmailLookupHandler {
    async lookup(number: string, allowLandline: boolean = false): Promise<LookupResponse> {
        return await APIHandler("/api/Carrier/Lookup", {
            method: "GET",
            data: { number, allowLandline },
            responseType: LookupResponse,
        });
    }
}
